import React from 'react';
import TimeSliceChart from '../../components/analytics/TimeSliceChart';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { useAnalyticsData } from '../../context/AnalyticsDataContext';

const TimeSection: React.FC = () => {
  const { filters } = useAnalyticsData();

  return (
    <>
      <Card>
        <CardHeader><CardTitle>By day of week</CardTitle></CardHeader>
        <CardContent><TimeSliceChart filters={filters} dimension="dow" /></CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>By hour of entry (IST)</CardTitle></CardHeader>
        <CardContent><TimeSliceChart filters={filters} dimension="hour" /></CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>By DTE bucket</CardTitle></CardHeader>
        <CardContent><TimeSliceChart filters={filters} dimension="dte" /></CardContent>
      </Card>
    </>
  );
};

export default TimeSection;
